module.exports = __webpack_public_path__ + "static/media/product_640-3.64ed27c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-3.jpg
// module id = 2386
// module chunks = 0